var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TextEditorComponent } from '../../../text-editor/text-editor.component';
import { Page } from '../../../core/types/models/Page';
import { Toast } from '../../../core/ui/toast.service';
import { Pages } from '../../../core/pages/pages.service';
var CrupdatePageComponent = /** @class */ (function () {
    function CrupdatePageComponent(pages, route, toast, router) {
        this.pages = pages;
        this.route = route;
        this.toast = toast;
        this.router = router;
        this.model = new Page();
        this.errors = {};
        this.loading = false;
    }
    CrupdatePageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            _this.getPage(params['id']);
        });
    };
    CrupdatePageComponent.prototype.createPage = function () {
        var _this = this;
        this.loading = true;
        this.pages.create(this.getPayload()).subscribe(function (page) {
            _this.router.navigate(['/admin/pages', page.id, 'edit']);
            _this.toast.open('Page Created');
            _this.errors = {};
            _this.loading = false;
        }, function (errors) {
            _this.errors = errors.messages;
            _this.loading = false;
        });
    };
    CrupdatePageComponent.prototype.updatePage = function () {
        var _this = this;
        this.loading = true;
        this.pages.update(this.model.id, this.getPayload()).subscribe(function () {
            _this.toast.open('Page Updated');
            _this.errors = {};
            _this.loading = false;
        }, function (errors) {
            _this.errors = errors.messages;
            _this.loading = false;
        });
    };
    CrupdatePageComponent.prototype.getPage = function (id) {
        var _this = this;
        if (!id)
            return;
        this.loading = true;
        this.pages.get(id).subscribe(function (page) {
            _this.model = page;
            _this.textEditor.setContents(_this.model.body || '');
            _this.loading = false;
        });
    };
    CrupdatePageComponent.prototype.getPayload = function () {
        this.model.body = this.textEditor.getContents();
        return __assign({}, this.model);
    };
    return CrupdatePageComponent;
}());
export { CrupdatePageComponent };
